// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2CJgK","inner":"Footer_inner__ye1mG"};